module.exports = __webpack_public_path__ + "media/effects-7.3b99c60b.webm";